import React, { useEffect } from "react";
import {
  Form,
  Input,
  Button,
  notification,
  Card,
  Select,
  Row,
  Col,
  Spin,
  Alert,
  Table,
  Divider,
  Space,
  Modal,
} from "antd";

import {
  AlertOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import ApiNotify from "../../api/notify/ApiNotify";
import TelegramGuideModal from "../../components/TelegramGuideModal";
import { useState } from "react";
import { ColumnsNotyfy } from "../../components/Columns/columns-notify";

const { Option } = Select;

const initialTypeNotifyItems = [
  { value: "DEPOSIT_WITHDRAW", label: "Deposit-Withdrawal Type" },
  { value: "DEPOSIT", label: "Deposit Type" },
  { value: "WITHDRAW", label: "Withdrawal Type" },
  // { value: "ERROR", label: "แจ้ง ERROR" },
  // { value: "ANNOUNCEMENT", label: "ประกาศข่าวสาร" },
  { value: "BANK_ACCOUNT", label: "Bank account", disabled: false },
];

export const FormEditRoom = ({
  item = {},
  onEditingRoom = () => { },
  loading = false,
  merchantId = 0,
  t,
}) => {
  const [form] = Form.useForm();
  const [typeNotifyItems, setTypeNotifyItems] = useState(
    initialTypeNotifyItems,
  );

  useEffect(() => {
    if (item) {
      let updatedItems = [...initialTypeNotifyItems];
      const currentTypeNotify = item.type_notify;

      const isInitialOrOther = initialTypeNotifyItems.some(
        (i) => i.value === currentTypeNotify,
      );

      if (currentTypeNotify && !isInitialOrOther) {
        updatedItems = [
          ...initialTypeNotifyItems.map((i) =>
            i.value === "other" ? { ...i, disabled: true } : i,
          ),
          {
            value: currentTypeNotify,
            label: currentTypeNotify,
            isCustom: true,
          },
        ];
        setTypeNotifyItems(updatedItems);
      } else {
        setTypeNotifyItems(initialTypeNotifyItems);
      }

      form.setFieldsValue({
        chat_id: item.chat_id,
        room_name: item.room_name,
        bot_token: item.bot_token,
        channel: item.channel,
        merchantID: merchantId,
        type_notify: currentTypeNotify,
      });
    }
  }, [item, form, merchantId]);

  const onFinish = async (values) => {
    // โค้ดส่วนนี้ถูกต้องอยู่แล้ว
    const currentValues = form.getFieldsValue();
    const initialValues = {
      chat_id: item.chat_id,
      room_name: item.room_name,
      bot_token: item.bot_token,
      channel: item.channel,
      merchantID: merchantId,
      type_notify: item.type_notify,
    };

    const updatedFields = {};
    let hasChanges = false;

    for (const key in currentValues) {
      if (currentValues[key] !== initialValues[key]) {
        updatedFields[key] = currentValues[key];
        hasChanges = true;
      }
    }

    if (!hasChanges) {
      notification.info({
        message: "ไม่มีการเปลี่ยนแปลง",
        description: "ข้อมูลในฟอร์มไม่มีการแก้ไข",
      });
      return;
    }
    const payload = {
      uuid: item.uuid,
      ...updatedFields,
    };

    try {
      await onEditingRoom(payload);
    } catch (error) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "ไม่สามารถแก้ไขข้อมูลได้",
      });
      console.error(error);
    }
  };

  return (
    <Spin spinning={loading}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col className="col-lg-6 col-md-6 col-sm-12">
            <Form.Item name="chat_id" label={t("Telegram Chat ID")}>
              <Input placeholder="YOUR_TELEGRAM_CHAT_ID example: -1234567890" />
            </Form.Item>
          </Col>
          <Col className="col-lg-6 col-md-6 col-sm-12">
            <Form.Item name="room_name" label={t("ชื่อกลุ่ม telegram")}>
              <Input
                placeholder={t("กรอกชื่อห้อง เช่น ฝากเงิน , ถอนเงิน ฯลฯ")}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col className="col-lg-6 col-md-6 col-sm-12">
            <Form.Item name="bot_token" label={t("Telegram Bot Token")}>
              <Input placeholder="********************" />
            </Form.Item>
          </Col>
          <Col className="col-lg-6 col-md-6 col-sm-12">
            <Form.Item name="channel" label={t("channel")}>
              <Select placeholder={t("เลือกช่องทาง")}>
                <Option value="telegram">{t("Telegram")}</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col className="col-lg-6 col-md-6 col-sm-12 ">
            <Space.Compact>
              <Form.Item name="type_notify" label={t("ประเภทการแจ้งเตือน")}>
                <Select
                  style={{ width: 300 }}
                  placeholder={t("Select notification type")}
                  name="type_notify"
                  // popupRender={renderTypeNotifyDropdown}
                  defaultValue={t(item?.type_notify || "")}
                >
                  {typeNotifyItems.map((item) => (
                    <Option
                      key={item.value}
                      value={item.value}
                      disabled={item.disabled}
                    >
                      {t(item.label)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Space.Compact>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t("Save")}
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};

class SetNotify extends React.Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      isModalVisible: false,
      loading: false,
      editingLoading: false,
      editRoomData: null,
      editRoomID: 0,
      activeForm: "",
      txtDivider: "Add Notification Room",
      isVisible: false,
      showOtherTypeNotifyInput: false,
      typeNotifyItems: initialTypeNotifyItems,
      newName: "", // ค่าที่ผู้ใช้พิมพ์ใน input เพิ่มรายการใหม่
      selectAddIndex: initialTypeNotifyItems.length,
    };
    this.toggleStatus = this.toggleStatus.bind(this);
  }

  componentDidMount() {
    this.props.fetchDataSetingNotify();
  }

  onFinishNotificationRoom = async (values) => {
    this.setState({ loading: true });
    let { merchantId } = this.props;

    try {
      const payload = {
        ...values,
        bot_token: String(values.bot_token),
        status: 1,
        merchantID: merchantId,
        type_notify: values?.type_notify,
      };
      const res = await ApiNotify.addRoomNotify(payload);
      if (res.data.success) {
        this.setState({ loading: false, activeForm: "" });
        notification.success({
          message: "สำเร็จ",
          description: res.data.msg,
        });
        this.formRef.current.resetFields();
        this.props.fetchDataSetingNotify();
      } else {
        this.setState({ loading: false });
        notification.error({
          message: "error",
          description: res.data.msg,
        });
      }
    } catch (error) {
      notification.error({
        message: `error : ${error.status}`,
        description:
          error?.response?.data?.msg || "ไม่สามารถตั้งค่าห้องแจ้งเตือนได้",
      });
      this.setState({ loading: false });
      console.error(error);
    }
  };

  // toggling  status
  toggleStatus = async (uuid, currentStatus) => {
    this.setState({ loading: true });
    try {
      let payload = {
        uuid,
        status: currentStatus === 1 ? 0 : 1,
      };
      const res = await ApiNotify.editingRoom(payload);
      if (res.data.success) {
        this.setState({ loading: false });
        notification.success({
          message: "สำเร็จ",
          description: "อัปเดตสถานะเรียบร้อยแล้ว",
        });
        this.props.fetchDataSetingNotify();
      } else {
        this.setState({ loading: false });
        notification.error({
          message: "error",
          description: res.data.msg,
        });
      }
    } catch (error) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "ไม่สามารถอัปเดตสถานะได้",
      });
      this.setState({ loading: false });
      console.error(error);
    }
  };
  // Edit
  onEditingRoom = async (payload) => {
    this.setState({ loading: true });
    try {
      const res = await ApiNotify.editingRoom(payload);
      if (res.data.success) {
        this.setState({
          loading: false,
          editingLoading: false,
          editRoomID: 0,
          activeForm: "",
        });
        notification.success({
          message: "สำเร็จ",
          description: "อัปเดตข้อมูลเรียบร้อยแล้ว",
        });
        this.props.fetchDataSetingNotify();
      } else {
        this.setState({ loading: false, editingLoading: false, editRoomID: 0 });
        notification.error({
          message: "error",
          description: res.data.msg,
        });
      }
    } catch (error) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "ไม่สามารถแก้ไขข้อมูลได้",
      });
      this.setState({ loading: false, editingLoading: false, editRoomID: 0 });
      console.error(error);
    }
  };

  //delete
  deleteRoom = async (uuid) => {
    this.setState({ loading: true });
    try {
      let payload = {
        uuid: uuid,
      };
      const res = await ApiNotify.deleteRoom(payload);
      if (res.data.success) {
        this.setState({ loading: false });
        notification.success({
          message: "สำเร็จ",
          description: "ลบห้องแจ้งเตือนเรียบร้อยแล้ว",
        });
        this.props.fetchDataSetingNotify();
      } else {
        this.setState({ loading: false });
        notification.error({
          message: "error",
          description: res.data.msg,
        });
      }
    } catch (error) {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "ไม่สามารถอัปเดตสถานะได้",
      });
      this.setState({ loading: false });
      console.error(error);
    }
  };


  handleEditRoom = (event, record) => {
    window.scrollTo(0, 0);
    if (event === "edit" && record) {
      this.setState({
        editRoomData: record,
        activeForm: event,
        editRoomID: record.id,
        editingLoading: true,
      });
    }
  };
  handleCloseEditRoom = () => {
    this.setState({
      editRoomData: null,
      activeForm: "",
      editRoomID: 0,
      editingLoading: false,
    });
  };
  onCancel = () => {
    let target = this.state.isVisible;
    this.setState({ isVisible: !target });
  };

  onNameChange = (event) => {
    this.setState({ newName: event.target.value });
  };
  addItem = (e) => {
    e.preventDefault();
    const { newName, typeNotifyItems } = this.state;
    if (newName && !typeNotifyItems.find((item) => item.label === newName)) {
      this.setState((prevState) => ({
        typeNotifyItems: [
          ...prevState.typeNotifyItems.map((item) =>
            item.value === "other" ? { ...item, disabled: true } : item,
          ),
          { value: newName, label: newName, isCustom: true },
        ],
        newName: "",
        selectAddIndex: prevState.selectAddIndex + 1,
      }));

      this.formRef.current.setFieldsValue({
        type_notify: newName,
      });
    }
  };
  renderTypeNotifyDropdown = (menu) => {
    const { newName } = this.state;
    return (
      <>
        {menu}
        <Divider style={{ margin: "8px 0" }} />
        <Space style={{ padding: "0 8px 4px", width: "100%" }}>
          <Input
            width={100}
            placeholder="ป้อนประเภทการแจ้งเตือนอื่น ๆ"
            value={newName}
            onChange={this.onNameChange}
            onKeyDown={(e) => e.stopPropagation()}
            style={{ flexGrow: 1 }}
          />
          <Button
            type="text"
            icon={<PlusOutlined />}
            onClick={this.addItem}
            disabled={!newName.trim()}
          >
            เพิ่ม
          </Button>
        </Space>
      </>
    );
  };
  render() {
    const { resDataSetingNotify, merchantId, nameMerchang, t, canaddNotify, canEditNotify, canDelSetNotify, canOn_offNotify } =
      this.props;
    const {
      loading,
      activeForm,
      editRoomData,
      editRoomID,
      editingLoading,
      isVisible,
    } = this.state;
    const { toggleStatus, handleEditRoom, deleteRoom } = this;
    if (!this.props.merchantId) {
      return (
        <Alert type="warning" className="p-3">
          ไม่พบข้อมูล Merchant
        </Alert>
      );
    }
    const dataSource = resDataSetingNotify || [];
    dataSource.sort((a, b) => {
      if (a.status === 1 && b.status === 0) {
        return -1;
      }
      if (a.status === 0 && b.status === 1) {
        return 1;
      }
      return 0;
    });

    const columns = ColumnsNotyfy(
      nameMerchang,
      toggleStatus,
      handleEditRoom,
      deleteRoom,
      editRoomID,
      t,
      canEditNotify,
      canDelSetNotify,
      canOn_offNotify
    );
    const { typeNotifyItems } = this.state;

    const options = typeNotifyItems.map((item) => ({
      label: item.label,
      value: item.value,
      disabled: item.disabled,
    }));
    return (
      <>
        <TelegramGuideModal isVisible={isVisible} onCancel={this.onCancel} />

        {/* เพิ่มกลุ่มแจ้งเตือน */}
        <Modal
          title={t("เพิ่มกลุ่มแจ้งเตือน")}
          closable={false}
          maskClosable={false}
          open={activeForm === "add"}
          width={785}
          footer={[
            <Button onClick={() => this.setState({ activeForm: "" })}>
              {t("close")}
            </Button>,
          ]}
        >
          <Spin spinning={loading}>
            {/* Form Add Room */}
            <div className={""}>
              <Form
                id="FormAddRoom"
                ref={this.formRef}
                layout="vertical"
                onFinish={this.onFinishNotificationRoom}
              >
                <Row gutter={16}>
                  <Col className="col-lg-6 col-md-6 col-sm-12 ">
                    <Form.Item
                      name="chat_id"
                      label={
                        <>
                          <span style={{ marginRight: "5px" }}>
                            {t("Telegram Chat ID")}
                          </span>{" "}
                          <QuestionCircleOutlined
                            title={t("Learn more")}
                            style={{ cursor: "pointer", color: "#007bff" }}
                            onClick={() => this.onCancel()}
                          />
                        </>
                      }
                      rules={[
                        { required: true, message: t("Please enter Chat ID!") },
                      ]}
                    >
                      <Input placeholder="YOUR_TELEGRAM_CHAT_ID example: -1234567890" />
                    </Form.Item>
                  </Col>
                  <Col className="col-lg-6 col-md-6 col-sm-12 ">
                    <Form.Item
                      name="room_name"
                      label={t("ชื่อกลุ่ม telegram")}
                      rules={[
                        {
                          required: true,
                          message: t("Please enter a room name!"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={t(
                          "กรอกชื่อห้อง เช่น ฝากเงิน , ถอนเงิน ฯลฯ",
                        )}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col className="col-lg-6 col-md-6 col-sm-12 ">
                    <Form.Item
                      name="bot_token"
                      label={
                        <>
                          <span style={{ marginRight: "5px" }}>
                            {t("Telegram Bot Token")}
                          </span>{" "}
                          <QuestionCircleOutlined
                            onClick={() => this.onCancel()}
                            title={t("Learn more")}
                            style={{ cursor: "pointer", color: "#007bff" }}
                          />
                        </>
                      }
                      rules={[
                        { required: true, message: "Please enter Bot Token!" },
                      ]}
                    >
                      <Input placeholder="YOUR_TELEGRAM_BOT_TOKEN" />
                    </Form.Item>
                  </Col>
                  <Col className="col-lg-6 col-md-6 col-sm-12 ">
                    <Form.Item
                      name="channel"
                      label={t("channel")}
                      initialValue={"telegram"}
                      rules={[
                        {
                          required: true,
                          message: t("Please select a channel!"),
                        },
                      ]}
                    >
                      <Select placeholder={t("Select Channel")}>
                        <Option value="telegram">{t("Telegram")}</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="col-lg-6 col-md-6 col-sm-12 ">
                    <Space.Compact>
                      <Form.Item
                        name="type_notify"
                        label={t("ประเภทการแจ้งเตือน")}
                        rules={[
                          {
                            required: true,
                            message: t("Please select notification type!"),
                          },
                        ]}
                      >
                        <Select
                          style={{ width: 300 }}
                          placeholder={t("Select notification type")}
                          name="type_notify"
                        // popupRender={this.renderTypeNotifyDropdown}
                        >
                          {options.map((item) => (
                            <Option
                              key={item.value}
                              value={item.value}
                              disabled={item.disabled}
                            >
                              {t(item.label)}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Space.Compact>
                  </Col>
                </Row>
                <Form.Item>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    {loading ? "loading..." : t("Submit")}
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Spin>
        </Modal>

        {/* แก้ไขข้อมูล */}
        <Modal
          title={t("Edit notification room")}
          maskClosable={false}
          closable={false}
          open={activeForm === "edit"}
          width={785}
          footer={[
            <Button onClick={() => this.handleCloseEditRoom()}>
              {t("close")}
            </Button>,
          ]}
        >
          <>
            <Spin spinning={loading}>
              <div className={""}>
                <FormEditRoom
                  onEditingRoom={this.onEditingRoom}
                  item={editRoomData}
                  loading={loading}
                  merchantId={merchantId}
                  t={t}
                />
              </div>
            </Spin>
          </>
        </Modal>
        <Row gutter={[8, 0]} className="">
          <Col className="col-sm-12 col-xs-12 col-lg-12 col-md-12">
            <Card
              type="inner"
              title={
                <>
                  <Button
                    className={`${!canaddNotify ? "d-none" : ""}`}
                    onClick={() => canaddNotify ? this.setState({ activeForm: "add" }) : alert(t("You don't have permission to add notification group"))}
                    children={t("เพิ่มกลุ่มแจ้งเตือน")}
                    icon={<PlusOutlined style={{ fontSize: 14 }} />}
                  />{" "}
                </>
              }
              className="p-3"
            >
              <div className="">
                <Divider orientation="left">
                  <AlertOutlined /> {t("Notification Room")}
                </Divider>
                <div className="body table-responsive">
                  <Spin
                    spinning={editingLoading}
                    tip={editingLoading ? "editing..." : ""}
                  >
                    <Table
                      scroll={{ x: "max-content" }}
                      dataSource={dataSource}
                      loading={loading}
                      columns={columns}
                    />
                  </Spin>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default SetNotify;
